var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 17.9977H8.0013C7.64768 17.9977 7.30854 17.8572 7.05849 17.6072C6.80844 17.3571 6.66797 17.018 6.66797 16.6644C6.66797 16.3108 6.80844 15.9716 7.05849 15.7216C7.30854 15.4715 7.64768 15.3311 8.0013 15.3311H24.0013C24.3549 15.3311 24.6941 15.4715 24.9441 15.7216C25.1942 15.9716 25.3346 16.3108 25.3346 16.6644C25.3346 17.018 25.1942 17.3571 24.9441 17.6072C24.6941 17.8572 24.3549 17.9977 24.0013 17.9977Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIconBlack);
export default __webpack_public_path__ + "static/media/minus-icon-black.01c278d1168871af4c45a4c9c90bdcd6.svg";
export { ForwardRef as ReactComponent };